export default class FileExtensionValidator {
  constructor(private extensions: string[]) {}
  public validate(filePath: string) {
    const ext = `.${filePath.split('.').pop() || ''}`
    return this.extensions.includes(ext)
  }
}
